import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const setupV2: RouteRecordRaw = {
  name: 'admin.setup-v2',
  path: 'setup-v2',
  component: () => import('pages/SetupV2.vue'),
  meta: {
    roles: [Roles.OrgAdmin, Roles.SuperAdmin],
    supportedPlatforms: ['desktop'],
    excludeEnv: [],
  },
}
